import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';

const ArrowTooltips = (props) => {
    const child = React.isValidElement(props.children) && props.children.props.title
        ? React.cloneElement(props.children, { title: undefined })
        : props.children;

    // return props.children
    return (
        <Tooltip placement="top" title={props.text} arrow>
            {child}
         </Tooltip>
    );
}

export default ArrowTooltips;